'use strict';

const sports = {
  AMERICAN_FOOTBALL: 'AmericanFootball',
  AQUAGYM: 'Aquagym',
  ARCHERY: 'Archery',
  ATHLETICS: 'Athletics',
  BADMINTON: 'Badminton',
  BASEBALL: 'Baseball',
  BASKETBALL: 'Basketball',
  BOXING: 'Boxing',
  CARDIO_TRAINING: 'CardioTraining',
  CRICKET: 'Cricket',
  CROSS_COUNTRY_SKIING: 'CrossCountrySkiing',
  CROSSFIT: 'Crossfit',
  CYCLING: 'Cycling',
  DANCE: 'Dance',
  ECO_ACTION: 'EcoAction',
  ELECTRIC_BIKE: 'ElectricBike',
  ELLIPTICAL_TRAINER: 'EllipticalTrainer',
  ESPORT: 'ESport',
  EXTREME_SPORTS: 'ExtremeSports',
  FENCING: 'Fencing',
  GARDENING: 'Gardening',
  GOLF: 'Golf',
  HANDBALL: 'Handball',
  HANDBIKE: 'Handbike',
  HIKING: 'Hiking',
  HOCKEY: 'Hockey',
  HORSE_RIDING: 'HorseRiding',
  ICE_SKATING: 'IceSkating',
  INDOOR_CYCLING: 'IndoorCycling',
  INDOOR_ROWING: 'IndoorRowing',
  KAYAKING: 'Kayaking',
  KITESURF: 'Kitesurf',
  MARTIAL_ARTS: 'MartialArts',
  MECHANICAL_SPORTS: 'MechanicalSports',
  MEDITATION: 'Meditation',
  MOUNTAIN_BIKE: 'MountainBike',
  NETBALL: 'Netball',
  PADEL: 'Padel',
  PETANQUE: 'Petanque',
  PILATE_GYM: 'PilateGym',
  ROCK_CLIMB: 'RockClimb',
  ROLLER: 'Roller',
  ROWING: 'Rowing',
  RUGBY: 'Rugby',
  RUNNING: 'Running',
  RUN_WHEELCHAIR: 'RunWheelchair',
  SAIL_AND_BOARD: 'SailAndBoard',
  SCUBA_DIVING: 'ScubaDiving',
  SHOOTING_SPORTS: 'ShootingSports',
  SKIING: 'Skiing',
  SNOWBOARD: 'Snowboard',
  SOCCER: 'Soccer',
  SPEED_SKATING: 'SpeedSkating',
  SQUASH: 'Squash',
  STREET_WORKOUT: 'StreetWorkout',
  STRETCHING: 'Stretching',
  SURF: 'Surf',
  SWIMMING: 'Swimming',
  TABLE_TENNIS: 'TableTennis',
  TENNIS: 'Tennis',
  TREADMILL: 'Treadmill',
  VOLLEYBALL: 'Volleyball',
  WALKING: 'Walking',
  WALK_WHEELCHAIR: 'WalkWheelchair',
  WHEELCHAIR: 'Wheelchair',
  WATER_POLO: 'WaterPolo',
  WEIGHT_TRAINING: 'WeightTraining',
  WINDSURF: 'Windsurf',
  WORKOUT: 'Workout',
  YOGA: 'Yoga',
};

module.exports = sports;
